// extracted by mini-css-extract-plugin
module.exports = {"option":"e8W+K","option-title":"_3BZUZ"};